import axios from 'axios'
import { tokenStore } from '@auth/tokenStore'
import { useAuthStore } from '@auth/authStore'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
const TIMEOUT = 15000

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: TIMEOUT,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(
  config => {
    const token = tokenStore.getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  response => response,
  async error => {
    // TODO: to be implemented later on
    // const originalRequest = error.config
    // if (error.response?.status === 401 && !originalRequest._retry) {
    //   originalRequest._retry = true

    //   try {
    //     const refreshToken = tokenStore.getRefreshToken()
    //     if (refreshToken) {
    //       const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {
    //         refreshToken
    //       })
    //       const result = response.data.result

    //       if (result) {
    //         tokenStore.setTokens(result.AccessTokem, result.IdToken)
    //         const current = useAuthStore.getState()
    //         useAuthStore.getState().setAuth({
    //           user: result.UserID ?? current.user,
    //           userFirstName: result.UserFirstName ?? current.userFirstName,
    //           userLastName: result.UserLastName ?? current.userLastName,
    //           companyID: result.CompanyID ?? current.companyID,
    //           companyName: result.CompanyName ?? current.companyName,
    //           isAuthenticated: true
    //         })

    //         originalRequest.headers.Authorization = `Bearer ${result.AccessToken}`
    //         return api(originalRequest)
    //       }
    //     }
    //   } catch (refreshError) {
    //     tokenStore.clearTokens()
    //     useAuthStore.getState().logout()
    //     window.location.href = '/login'
    //     return Promise.reject(refreshError)
    //   }
    // }

    // Handle 401
    if (error.response?.status === 401) {
      const isLoginRequest = error.config?.url?.includes('/users/login')
      if (!isLoginRequest && tokenStore.getAccessToken()) {
        tokenStore.clearTokens()
        useAuthStore.getState().logout()
        window.location.href = '/login'
      }
    }

    // Handle 403
    if (error.response?.status === 403) {
      console.error('Insufficient permissions')
    }

    // Handle 404
    if (error.response?.status === 404) {
      console.error('Resource not found')
    }

    // Handle 500
    if (error.response?.status >= 500) {
      console.error('Server error occured')
    }

    // Handle network problems
    if (!error.response) {
      console.error('Network error - check your connection')
    }

    return Promise.reject(error)
  }
)
